import { z } from 'zod';
import type { ProjectPartsFragment } from '~/apollo/generated/v3/graphql';
import { ppStringOrNull } from '~/utils/zod';

export const projectSchema = z.object({
  name: z.string().min(1),
  description: z.string().min(1),
  comments: z.preprocess(ppStringOrNull, z.string().nullable()),
  hidden: z.boolean(),
});

export type ProjectFormValues = {
  name: string;
  description: string;
  comments: string;
  hidden: boolean;
};

export function initialProject(
  project?: ProjectPartsFragment,
): ProjectFormValues {
  return {
    name: project?.name ?? '',
    description: project?.description ?? '',
    comments: project?.comments ?? '',
    hidden: project?.hidden ?? false,
  };
}
